import { useAuth0 } from '@auth0/auth0-react';
import { Button, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { IconBan } from '@tabler/icons-react';

export default function SuspendedAccountPage() {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Container size="sm" py="xl">
      <Paper shadow="md" p="xl" radius="md">
        <Stack align="center" gap="lg">
          <IconBan size={64} color="var(--mantine-color-red-6)" />

          <Title order={1} ta="center" c="red">
            Account Suspended
          </Title>

          <Text size="lg" ta="center" c="dimmed">
            Your account has been suspended. Please contact support if this is unexpected.
          </Text>

          <Button variant="outline" color="red" onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
